module.exports = __webpack_public_path__ + "static/media/8OLA15.101ab725.jpg";